export default __webpack_public_path__ + "static/property-banner-415a6983fcc126088284f4e2a1643447.jpg";